import { enableProdMode, isDevMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

// import {Chart} from 'chart.js';
// import * as ChartDataLabels from 'chartjs-plugin-datalabels';

if (environment.production) {
  enableProdMode();
}

// Chart.plugins.register(ChartDataLabels as any);

platformBrowserDynamic()
.bootstrapModule(AppModule)
  .catch(err => {
    if (isDevMode()) {
      console.error(err);
    }
  });
